import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithoutBtn from 'components/root/partials/header/ShortHeaderWithoutBtn';
import { useNavigate } from "react-router-dom";

const EditMedicalRecordVerify = () => {

	const navigate = useNavigate();
	

    return (
        
        <div className={sharedStyles.container}>
        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithoutBtn />
        		
	            <div className={[formStyles.title, formStyles['mb-24'], formStyles['text-center']].join(' ')}>
                    پرونده پزشکی شما با موفقیت ثبت و در پروفایل کاربری شما ذخیره شد.
                </div>

                <div className={[formStyles['title-2'], formStyles['mb-24'], formStyles['text-center']].join(' ')}>
                    ویرایش اطلاعات پرونده پزشکی از طریق قسمت پروفایل اختصاصی شما  امکان پذیر میباشد.
                </div>

				
				<button onClick={() => navigate('/', { replace: true })} className={formStyles.button}>بازگشت به صفحه اصلی</button>
        	</div>

		</div>

    );
}

export default EditMedicalRecordVerify;